import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const ShopContext = createContext(null);
const keyOf = (i) => `${i.product_id}|${i.size}|${i.colour}`;

export function ShopProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [bagOpen, setBagOpen] = useState(false);
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("mm_bag") || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("mm_bag", JSON.stringify(items)); }, [items]);
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({})); }, []);

  const value = useMemo(() => {
    const add = (item) => {
      setItems((prev) => {
        const k = keyOf(item);
        const found = prev.find((p) => keyOf(p) === k);
        if (found) return prev.map((p) => (keyOf(p) === k ? { ...p, quantity: Math.min(p.quantity + item.quantity, item.max || 20) } : p));
        return [...prev, item];
      });
      setBagOpen(true);
    };
    const setQty = (k, q) => setItems((prev) => prev.map((p) => (keyOf(p) === k ? { ...p, quantity: Math.max(1, Math.min(q, p.max || 20)) } : p)));
    const remove = (k) => setItems((prev) => prev.filter((p) => keyOf(p) !== k));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const subtotal = items.reduce((s, i) => s + i.quantity * i.price, 0);
    return { settings, setSettings, items, add, setQty, remove, clear, count, subtotal, bagOpen, setBagOpen, keyOf };
  }, [items, settings, bagOpen]);

  return <ShopContext.Provider value={value}>{children}</ShopContext.Provider>;
}

export const useShop = () => useContext(ShopContext);
